import { render } from "./DialogForm.vue?vue&type=template&id=f6cda870"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"

import "./DialogForm.vue?vue&type=style&index=0&id=f6cda870&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__